import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { changePassword } from "auth/auth.actions";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { IApplicationState } from "redux/root-reducer";
import { createSelector } from "reselect";
import { ConfirmOrCancelDialog } from "./ConfirmOrCancelDialog";
import styles from "./changePassword.module.scss";
interface IChangePasswordModal {
  onClose(): any;
  open: boolean;
}

const getAuthState = createSelector(
  (state: IApplicationState) => state.auth,
  (authItems) => ({
    changePasswordFail: authItems.changePasswordFail,
  })
);
export const ChangePassword: React.FC<IChangePasswordModal> = (props) => {
  const { open, onClose } = props;
  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = React.useState<string>("");
  const [showCancelConfirm, setShowCancelConfirm] = useState<boolean>(false);
  const [repeatNewPassword, setRepeatNewPassword] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const { changePasswordFail } = useSelector(getAuthState);
  const { t } = useTranslation();

  const handleNewPassword = (input: string) => {
    setNewPassword(input);
  };

  const handleChangePassword = () => {
    if (newPassword !== repeatNewPassword) {
      setErrorMessage(t("Sorry, the password does not match"));
      return;
    }
    setShowCancelConfirm(true);
  };
  const handleConfirm = () => {
    dispatch(changePassword(newPassword));
    if (changePasswordFail) return;
    onClose();
  };

  useEffect(() => {
    return () => {
      setErrorMessage("");
      setNewPassword("");
      setRepeatNewPassword("");
      setShowCancelConfirm(false);
    };
  }, [onClose]);

  return (
    <Dialog onClose={onClose} open={open} fullWidth={true} maxWidth={"sm"}>
      <DialogContent>
        <DialogTitle className={styles.title}>
          {t("Change password")}
        </DialogTitle>
        <TextField
          onChange={(e) => {
            handleNewPassword(e.target.value);
          }}
          required
          type="password"
          fullWidth
          label={t("Enter new password")}
          variant="outlined"
        />
      </DialogContent>
      <DialogContent>
        <TextField
          onChange={(e) => {
            setRepeatNewPassword(e.target.value);
          }}
          required
          helperText={errorMessage}
          type="password"
          fullWidth
          label={t("Repeat the new password")}
          variant="outlined"
        />
      </DialogContent>
      <Box>
        <ConfirmOrCancelDialog
          open={showCancelConfirm}
          onClose={() => setShowCancelConfirm(false)}
          text={t("Are you sure you want to change your password?")}
          onConfirm={handleConfirm}
          confirmIsDelete={false}
        />
        <DialogActions>
          <Button size="large" onClick={onClose} color="primary" variant="text">
            {t("Cancel")}
          </Button>
          <Button
            size="large"
            onClick={handleChangePassword}
            color="primary"
            variant="contained"
            disabled={!repeatNewPassword || !newPassword}
          >
            {t("Change password")}
          </Button>
        </DialogActions>

        {changePasswordFail && (
          <Typography color="error">
            {t("An error occured, please try again")}
          </Typography>
        )}
      </Box>
    </Dialog>
  );
};

export default ChangePassword;
